/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './employees.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../navbar/navbar.component.ngfactory';
import * as i3 from '../../../../../../../app/components/navbar/navbar.component';
import * as i4 from '@angular/router';
import * as i5 from '../../../../../../../app/shared/_services/login.service';
import * as i6 from '@ngx-translate/core/src/translate.service';
import * as i7 from '../../../../../../../app/shared/_services/hca-user-management.service';
import * as i8 from '../../../../../../../app/shared/_services/util.service';
import * as i9 from '../../../../../../../app/components/admin/hca-admin/employees/employees/employees.component';
const styles_EmployeesComponent:any[] = [i0.styles];
export const RenderType_EmployeesComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_EmployeesComponent,data:{}});
export function View_EmployeesComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-navbar',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_NavbarComponent_0,
      i2.RenderType_NavbarComponent)),i1.ɵdid(1,114688,(null as any),0,i3.NavbarComponent,
      [i4.Router,i5.LoginService,i6.TranslateService,i7.HcaUserManagementService,i8.UtilService],
      (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
      i1.ɵeld(3,16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(4,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
    _ck(_v,4,0);
  },(null as any));
}
export function View_EmployeesComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-employees',
      ([] as any[]),(null as any),(null as any),(null as any),View_EmployeesComponent_0,
      RenderType_EmployeesComponent)),i1.ɵdid(1,114688,(null as any),0,i9.EmployeesComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const EmployeesComponentNgFactory:i1.ComponentFactory<i9.EmployeesComponent> = i1.ɵccf('app-employees',
    i9.EmployeesComponent,View_EmployeesComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vaGNhLWFkbWluL2VtcGxveWVlcy9lbXBsb3llZXMvZW1wbG95ZWVzLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2FkbWluL2hjYS1hZG1pbi9lbXBsb3llZXMvZW1wbG95ZWVzL2VtcGxveWVlcy5jb21wb25lbnQudHMiLCJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2FkbWluL2hjYS1hZG1pbi9lbXBsb3llZXMvZW1wbG95ZWVzL2VtcGxveWVlcy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vaGNhLWFkbWluL2VtcGxveWVlcy9lbXBsb3llZXMvZW1wbG95ZWVzLmNvbXBvbmVudC50cy5FbXBsb3llZXNDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLW5hdmJhcj48L2FwcC1uYXZiYXI+XG48cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+IiwiPGFwcC1lbXBsb3llZXM+PC9hcHAtZW1wbG95ZWVzPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTttQ0FBQSxVQUFBO01BQUE7TUFBQSw2QkFBeUIsMENBQ3pCO2FBQUE7VUFBQTthQUFBOzBEQUFBO1VBQUE7SUFEQTtJQUNBOzs7O29CQ0RBO01BQUE7bUNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/admin/hca-admin/employees/employees/employees.component.ngfactory.ts